//Authenticate

export const apiLogin = `/api/identity/login`
export const apiGoogleLogin = `/api/identity/google-login`
export const apiLogout = `/api/identity/logout`
export const apiRefreshToken = `/api/identity/refreshToken`
export const apiChangePassword = `/api/identity/changePassword`
export const apiGetInfo = `/api/identity/getInfo`
export const apiGetTabs = `/api/identity/getTabs`
export const apiUpdateAvatar = `/api/identity/updateAvatar`
export const apiUpdateInfo = `/api/identity/updateInfo`
export const apiChangeHistory = `/api/identity/changeHistory`
export const apiLoginGG = `/api/identity/google-login`
export const apiCompleteStaffDetails = `/api/identity/completeStaffDetails`
export const apiCompleteGuestDetails = `/api/identity/completeGuestDetails`
export const apiRegister = `/api/identity/register`
